import React, { ReactElement, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  CustomerSubscriptionAvailabilityModel,
  customerSubscriptionAvailabilityProvider,
  getCurrentPopupFromOpen,
  logger,
  Nullable,
  PopupsEnum,
} from '@lerna-core';
import {
  B2CFormSubscriptionContextModel,
  B2CFormSubscriptionContextProviderProps,
} from './b2cFormSubscription.model';

const B2CFormSubscriptionContext =
  React.createContext<Nullable<B2CFormSubscriptionContextModel>>(null);

export const B2CFormSubscriptionContextProvider = ({
  props,
  children,
}: B2CFormSubscriptionContextProviderProps): ReactElement => {
  const [
    personalSubscriptionAvailability,
    setPersonalSubscriptionAvailability,
  ] = useState<Nullable<CustomerSubscriptionAvailabilityModel>>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const currentPopup = useSelector(
    getCurrentPopupFromOpen(PopupsEnum.userOrderFormPopup)
  );

  const isSubmitButtonDisabled =
    isLoading || !personalSubscriptionAvailability?.isClaimAvailable;

  useEffect(() => {
    if (currentPopup && !personalSubscriptionAvailability) {
      customerSubscriptionAvailabilityProvider(props.course.uuid)
        .then((data) => {
          setPersonalSubscriptionAvailability(data);
        })
        .catch((err) => {
          logger.error('[ERROR]: can not get subscription availability', err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [personalSubscriptionAvailability, currentPopup]);

  const context = {
    personalSubscriptionAvailability,
    isSubmitButtonDisabled,
    isLoading,
  };

  return (
    <B2CFormSubscriptionContext.Provider value={context}>
      {children}
    </B2CFormSubscriptionContext.Provider>
  );
};

export const useB2CFormSubscriptionContext =
  (): B2CFormSubscriptionContextModel => {
    const value = useContext(B2CFormSubscriptionContext);

    if (!value) {
      logger.error('[ERROR]: you cannot use context without a provider');

      return {} as B2CFormSubscriptionContextModel;
    }

    return value;
  };
